import { defineStore } from "pinia";

import { Modal, message } from "ant-design-vue";
import DYWebRtcClient from "@js/webrtc";
import DYLongLinkClient from "@js/web/socket/websocket";
import * as Accounts from "@js/account";
import { isGameHtml } from "@js/utils";
import pb from "@pb/index.json";
import IPCCenter from "@js/ipc";
import { EVENTCMD } from "@js/events";
import stastic from "@js/stastic";
import Logger from "@js/logger";
import BusinessManager from "@js/controls";
import ERROR from "@js/error";
import CheckGameingWindow from "@js/checkGameingWindow";
import GameStateMgr from "@/js/game/GameStateMgr";
// import { clearMouseStoreKey } from "@component/Video";
import {
  PlayGameInterceptChain,
  CheckCanPlayGame,
  SelectGameConfig,
  GetGameTips,
  CheckInQueueOrGame,
  ChangeGame,
  SelectServerArea,
  PlayGame,
} from "@js/game/game-intercept";
import { gameWind, handleOpenGameWind } from "@js/game/game-window";
import { useloginStore } from "@/store/login";
import { IStateType } from "@/js/game/state/IGameState";
import logger from "@js/logger";

const yunpb = pb.nested.yunpb.nested;
const PLAYERSTATUS = yunpb.PlayerStatus.values;
// const ErrCommonCode = yunpb.ErrCommonCode.values; // 实名认证相关
const AutoUsePriorityType = yunpb.AutoUsePriorityType.values;
const QueueType = yunpb.QueueType.values;
const NodeErrorCode = yunpb.NodeErrorCode.values;

const putSelf: any = null;

const showToastMessage = (msg: string) => {
  message.destroy();
  message.error(msg, 3);
};

export const usePlayGameStore = defineStore("playGame", {
  state: () => {
    return {
      // 玩家状态数据
      playerStatusData: {} as pro.yunpb.IGetPlayerStatusRes,
      // 游戏面板弹窗的显示状态
      isVideoControl: false,
      // 游戏是否正在排队
      isQueueing: false,
      // 中间排队弹窗的显示状态
      queueModal: false,
      // 左侧悬浮窗的显示状态
      floatModal: false,
      // 游戏退出弹窗的显示状态
      exitModal: false,
      // 排队相关的数据
      queueData: {} as any,
      // chikii 排队相关数据
      roomInfo: {} as any,
      // 退出游戏相关的数据
      exitData: {} as any,
      // 是否正在玩游戏
      isPlaying: Number(Accounts.getIsPlayingGame()) > 0,
      // 判断退出弹框状态
      isExiting: false,
      // 秒进道具数据
      autoUsePriorityData: {
        type: AutoUsePriorityType.NoPriorityItem,
        tip: "",
      },
      // 联区选择弹窗
      areaListModal: false,
      areaData: {} as any,
      // 配置选择弹窗
      gameConfigModal: false,
      // 是否高配
      currGameIsHighLevel: false,
      selectGameIsHighLevel: false,
      // 可用时间
      canUseTime: 0,
      // 实名认证弹窗
      verificationRealNameModel: false,
      // 是否第一次加载游戏未结束弹窗
      isFirstLoadGameNotOver: true,
    };
  },
  actions: {
    // 设置游戏状态数据
    setPlayerStatus(playerStatus: any) {
      this.playerStatusData = playerStatus;
    },
    // 设置游戏面板的状态
    setVideoControlState(isShow: boolean) {
      this.isVideoControl = isShow;
    },
    setIsPlaying(isPlaying: boolean) {
      this.isPlaying = isPlaying;
    },
    // 重置多个弹窗的状态
    resetModalState() {
      this.queueModal = false;
      this.floatModal = false;
      this.exitModal = false;
      this.areaListModal = false;
    },
    // 显示左侧排队悬浮窗
    showFloatModal(payload: {
      playerOper?: number;
      queIndex?: number | null;
      waitTime?: number;
      queueInfo?: any;
    }) {
      this.queueModal = false;
      this.floatModal = true;
      this.exitModal = false;
      this.areaListModal = false;
      this.queueData = {
        ...this.queueData,
        ...payload,
      };
    },
    // 显示中间排队弹窗
    showQueueModal(payload: { playerOper?: number; countDown?: number }) {
      console.log("showQueueModal", payload.playerOper);

      this.queueModal = true;
      this.floatModal = false;
      this.exitModal = false;
      this.areaListModal = false;
      this.queueData = {
        ...this.queueData,
        ...payload,
      };
    },
    // 显示退出游戏弹窗
    showExitModal(payload: { from?: string | null; to?: string | null }) {
      this.queueModal = false;
      this.floatModal = false;
      this.exitModal = true;
      this.areaListModal = false;
      this.queueData = {
        ...this.queueData,
        ...payload,
      };
    },
    // 显示联机选择弹窗
    showAreaListModal(playload: any) {
      this.queueModal = false;
      this.floatModal = false;
      this.exitModal = false;
      this.areaListModal = true;
      this.areaData = {
        ...this.areaData,
        ...playload,
      };
    },
    // 打开游戏页面，显示左侧悬浮窗
    async handleOpenGame() {
      console.log("打开游戏页面");
      Modal.destroyAll();
      handleOpenGameWind();
      this.showFloatModal({ playerOper: PLAYERSTATUS.NO_OPER });
      this.isPlaying = true;
      Accounts.setIsPlayingGame(1);
    },
    // 排队面板
    async handleGetQueuePanel(gameId: number) {
      const res = await BusinessManager.GetGameRoomInfo(gameId);
      Logger.log(`handleGetQueuePanel ${JSON.stringify(res)}`);
      console.log("handleGetQueuePanel", res);

      if (res && res.code === 0) {
        const { obj } = res;
        this.roomInfo = obj;
      }
    },
    // 更新排队面板
    async handleRefreshQueuePanel(data: pro.yunpb.ICltQueChangeNotify) {
      logger.log("更新排队面板：handleRefreshQueuePanel");

      /**
       * 后端推送的排队数据中 WaitingNode 这个结构体中 optGoldInfo 是 null
       * 接收更新时不修改 optGoldInfo 的值
       * 坑爹接口！！！
       */
      this.roomInfo.queueInfo = data.queueInfo;
      this.roomInfo.normalWaitingNode = {
        ...this.roomInfo.normalWaitingNode,
        desc: data.normalWaitingNode?.desc,
        num: data.normalWaitingNode?.num,
        queueId: data.normalWaitingNode?.queueId,
      };
      this.roomInfo.newPayWaitingNode = {
        ...this.roomInfo.newPayWaitingNode,
        desc: data.newPayWaitingNode?.desc,
        num: data.newPayWaitingNode?.num,
        queueId: data.newPayWaitingNode?.queueId,
      };
      this.roomInfo.vipWaitingNode = {
        ...this.roomInfo.vipWaitingNode,
        desc: data.vipWaitingNode?.desc,
        num: data.vipWaitingNode?.num,
        queueId: data.vipWaitingNode?.queueId,
      };
    },
    // 取消排队
    // async handleCancelQueue() {
    //   const ret = await BusinessManager.CancelQue(Accounts.getAccountId());

    //   if (ret && ret.code === 0) {
    //     this.resetModalState();
    //     Accounts.setCurrentGame(null);
    //   } else {
    //     showToastMessage(ERROR.errorMessage(ret?.obj));
    //   }
    // },
    async handleEnterGame(game: pro.yunpb.IGetGameRoomInfoRsp) {
      const gameInfo = game.gameBaseInfo;
      const { areaId } = this.areaData;

      if (!game) return;

      Logger.log(`handleEnterGame: ${gameInfo?.gameId}`);

      const gameId = gameInfo?.gameId;
      const isOnlineGame = gameInfo?.gameId;

      if (gameId) {
        const data: pro.yunpb.ICltPlayGameReq = {
          gameId,
          accountId: Number(Accounts.getAccountId()),
        };

        isOnlineGame && areaId && (data.areaId = areaId);

        const ret: WebSocketRes<pro.yunpb.ICltPlayGameRes> =
          (await BusinessManager.PlayGame(
            data
          )) as WebSocketRes<pro.yunpb.ICltPlayGameRes>;
        console.log("启动游戏返回", ret);

        if (ret && ret.code === 0) {
          if (!ret.obj) {
            Logger.log(`PlayGame return empty object`);
            this.resetModalState();
            return;
          }

          this.isQueueing = true;
          // this.currGameIsHighLevel = ret.obj.queueInfo?.isHighLevel;

          Accounts.setCurrentGame(ret.obj.gameNode!);

          switch (ret.obj.playerOper) {
            case PLAYERSTATUS.PLAY_GAME: {
              this.handleOpenGame();
              break;
            }
            case PLAYERSTATUS.NO_OPER:
            case PLAYERSTATUS.IN_QUE: {
              await this.showQueueModal({ playerOper: PLAYERSTATUS.IN_QUE });
              await this.handleGetQueuePanel(gameId);
              break;
            }
            case PLAYERSTATUS.NO_SERVER_FOR_USE: {
              Modal.confirm({
                title: "Tips",
                content: "Your host is occupied.",
                okText: "Cancel the queue",
                cancelText: "Continue to wait",
                centered: true,
                onOk: async () => {
                  // TODO: 无法使用put， 暂时使用putSelf代替
                  // await this.handleCancelQueue();
                },
                onCancel: async () => {
                  await this.showFloatModal({
                    playerOper: PLAYERSTATUS.IN_QUE,
                  });
                },
              });
              break;
            }
          }
        } else {
          showToastMessage(ret?.msg);
        }
      } else {
        // switch (ret)
      }
    },
    // 重启游戏
    // RestartGame接口参数说明
    // restart_type：需要切换steam账号传1
    // mode：收到推送SaveDocumentsNotice，且错误码为1（存档被占用需要关闭游戏,再重启），这时重启游戏mode传1
    // 由于web暂时还没有存档跟切换steam账号的功能，因此固定传0
    async handleRestartGame() {
      try {
        const res = await BusinessManager.RestartGame({
          restartType: 0,
          mode: 0,
        });
        Logger.log(`handleRestartGame ${JSON.stringify(res)}`);
        if (res?.code !== 0) {
          message.error({
            content: ERROR.errorMessage(res?.obj) || res?.code,
          });
        }
      } catch (error) {
        console.log(error, "handleRestartGameErr");
      }
    },
    // 退出游戏
    async handleGameExit() {
      Logger.log("handleGameExit");
      await BusinessManager.ExitGame(Accounts.getAccountId());
      IPCCenter.getInstance().broadCastEvent(EVENTCMD.AfterExitGame, {});
      Accounts.setIsPlayingGame(0);
      Accounts.setRTCConnected(0);
      this.isPlaying = false;
      this.resetModalState();
    },
    // 取消切换游戏
    async handleCancelExit() {
      const isQueueing = this.isQueueing;
      if (gameWind && !gameWind.closed) {
        this.showFloatModal({ playerOper: PLAYERSTATUS.NO_OPER });
      } else if (isQueueing) {
        this.showFloatModal({ playerOper: PLAYERSTATUS.IN_QUE });
      } else {
        this.showFloatModal({ playerOper: PLAYERSTATUS.NO_OPER });
      }
    },
    // 开启游戏, 验证游戏环境
    handlePlayGameMessage(payload: any) {
      const game: any = payload;
      const intercepts = new PlayGameInterceptChain();
      const checkInQueueOrGame = new CheckInQueueOrGame();
      // const selectServerArea = new SelectServerArea();
      // checkInQueueOrGame.setJumpIntercept(selectServerArea);
      intercepts.add(new CheckCanPlayGame());
      // intercepts.add(new SelectGameConfig());
      // intercepts.add(new GetGameTips());
      intercepts.add(checkInQueueOrGame);
      // intercepts.add(new ChangeGame());
      intercepts.add(new PlayGame());
      intercepts.start(game);
    },
    // 用户取消返回游戏
    async handleCancelBackGame() {
      // Logger.log(`handleCancelBackGame exit game`);
      // const isQueueing = this.isQueueing;
      // if (isQueueing) {
      //   this.handleCancelQueue();
      // } else {
      //   const exist = await CheckGameingWindow.checkIfExistGamingWindow();
      //   Logger.log(`handleCancelBackGame exit game`);
      //   if (!exist) {
      //     this.handleGameExit();
      //   }
      // }
    },
    handleKickout() {
      const loginStore = useloginStore();
      DYLongLinkClient.getInstance().disconnect();

      if (isGameHtml()) {
        DYWebRtcClient.getInstance().disconnect();
        setTimeout(() => {
          if (window.opener) {
            window.opener = null;
            window.open("", "_self");
            window.close();
          } else {
            showToastMessage("当前页面已经失效");
          }
        }, 100);
      }

      this.resetModalState();
      loginStore.clearLoginState();
    },
  },
});
